import React from 'react';
import { Grid } from '@mui/material';

import Section from '../../../layout/Section';
import InputFieldNumber from '../../../common/inputs/InputFieldNumber';
import { MarktpreisTariff, MarktpreisTariffUpdate } from '../../../../types';

const TOOLTIPS = {
    verkaufspreis: 'Erwarteter Marktpreis für den Stromverkauf nach Ablauf der EEG-Förderung.',
    einkaufspreis: 'Erwarteter Marktpreis für den Stromzukauf, z.\u00a0B. zur Erfüllung von PPA-Lieferverpflichtungen.',
    kommunaleBeteiligung: 'Abgabe an die Standortkommune gemäß §\u00a06 EEG. Der Betrag wird pro eingespeister kWh vom Erlös abgezogen.',
};

interface MarketPriceSectionProps {
    marktpreisTariff: MarktpreisTariff | null;
    canEdit: boolean;
    onMarktpreisChange: (field: keyof MarktpreisTariffUpdate) => (value: string) => void;
}

/**
 *
 * Zeigt Verkaufspreis und Einkaufspreis für den Strommarkt.
 */
const MarketPriceSection: React.FC<MarketPriceSectionProps> = ({
    marktpreisTariff,
    canEdit,
    onMarktpreisChange,
}) => {
    const numToStr = (value: number | undefined | null): string => {
        if (value === undefined || value === null) return '';
        return String(value);
    };

    return (
        <Section title="Preise und Abgaben">
            <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <InputFieldNumber
                        label="Verkaufspreis"
                        value={numToStr(marktpreisTariff?.marktpreis_kwh)}
                        onChange={onMarktpreisChange('marktpreis_kwh')}
                        readOnly={!canEdit}
                        suffix="Cent/kWh"
                        tooltip={TOOLTIPS.verkaufspreis}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <InputFieldNumber
                        label="Einkaufspreis"
                        value={numToStr(marktpreisTariff?.einkaufspreis_kwh)}
                        onChange={onMarktpreisChange('einkaufspreis_kwh')}
                        readOnly={!canEdit}
                        suffix="Cent/kWh"
                        tooltip={TOOLTIPS.einkaufspreis}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <InputFieldNumber
                        label="Kommunale Beteiligung"
                        value={numToStr(marktpreisTariff?.kommunale_beteiligung_kwh)}
                        onChange={onMarktpreisChange('kommunale_beteiligung_kwh')}
                        readOnly={!canEdit}
                        suffix="Cent/kWh"
                        tooltip={TOOLTIPS.kommunaleBeteiligung}
                    />
                </Grid>
            </Grid>
        </Section>
    );
};

export default React.memo(MarketPriceSection);
